export const RoutesWeb = {
    HOME: '/',
    DETAILS: '/detalles',
    DETAILS_TICKET: '/detalles/tickets/:obj',
    PAYMENT: '/pago/:obj',
    /** Habilitar con REACT_APP_ENABLE_PAYPAL_DEBUG=true */
    PAYMENT_DEBUG: '/debug/pago-paypal',
    RESEND_TICKETS: '/recuperar-boletos',
    THANKS_FULL: '/gracias/:obj',
    LOGIN_GROUP: '/login',
    REGISTER_GROUP: '/registrar-grupo',
    REGISTER_GROUP_THANKS: '/registrar-grupo/gracias/:obj',
    ADMIN_LOGIN: '/admin',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_ADD_LEADER: '/admin/leader',
    EDIT_EVENT: '/admin/event/edit',
    ADMIN_LEADERS: '/admin/leaders',
    ADMIN_SCAN_TICKETS: '/admin/scan-ticket',
    ADMIN_DECANATO_LOADS: '/admin/decanato-loads',
    THANKS: (obj) => {
        if(obj === null){
            const regex = /:obj/g;
            return '/gracias/:obj'.replace(regex, obj);
        } else {
            return '/gracias/:obj';
        }
    }
}